// G1-D: Web Push helpers without imports (tested by Jest).

// VAPID public key (base64url) -> Uint8Array for pushManager.subscribe
export function kunciKeBytes(base64url) {
  const pad = "=".repeat((4 - (base64url.length % 4)) % 4);
  const b64 = (base64url + pad).replace(/-/g, "+").replace(/_/g, "/");
  const raw = typeof atob === "function" ? atob(b64) : Buffer.from(b64, "base64").toString("binary");
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

// What the "notifications on this phone" box should say.
export function statusPush({ didukung, izin, berlangganan, mode }) {
  if (!didukung) return { kode: "TIDAK_DIDUKUNG", teks: "Browser ini tidak mendukung notifikasi push (butuh HTTPS atau localhost)." };
  if (izin === "denied") return { kode: "DITOLAK", teks: "Izin notifikasi diblokir. Buka pengaturan situs di browser untuk mengizinkan." };
  if (berlangganan) {
    return mode === "simulasi"
      ? { kode: "SIMULASI", teks: "Perangkat terdaftar, tetapi server dalam mode simulasi (kunci VAPID belum diatur) — push tidak dikirim." }
      : { kode: "AKTIF", teks: "Notifikasi HP aktif di perangkat ini." };
  }
  return { kode: "MATI", teks: "Notifikasi HP belum aktif di perangkat ini." };
}

// Bell badge text.
export const lencana = (n) => (!n ? "" : n > 99 ? "99+" : String(n));

// Event types in the order shown in Pengaturan → Notifikasi.
export const NOTIF_JENIS = [
  ["NOTA_BATAL", "Nota batal"],
  ["KOREKSI_BAYAR", "Koreksi pembayaran"],
  ["KELEBIHAN_DEKAT", "Kelebihan bayar mendekati batas 2×24 jam"],
  ["SELISIH_QTY", "Selisih qty produksi"],
  ["SPK_LEWAT_HARIAN", "Ringkasan harian SPK lewat rencana"],
  ["SPK_LEWAT", "SPK lewat rencana (per SPK)"],
  ["KELEBIHAN_LEWAT", "Kelebihan bayar lewat batas"],
  ["QC_REJECT", "QC reject"],
  ["STOK_MENIPIS", "Stok menipis"],
  ["WA_GAGAL", "WhatsApp gagal"],
  ["STOK_REWORK", "Stok rework (minus / gagal)"],
  ["ULASAN_RENDAH", "Penilaian customer rendah (1–2 bintang)"],
  ["REVISI_LEWAT_BATAS", "Revisi ACC melewati batas (perlu persetujuan)"],
  ["REVISI_SELESAI", "Revisi desain selesai (juga lonceng CS pemegang order & Manager)"],  // v2.19
];
